"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAkitaBoxClient = void 0;
function createAdminCustomerAccountsClient(api) {
    return {
        accountCreate: (...args) => api["accountCreate"](...args),
        count: (...args) => api["adminCustomerAccountsCount"](...args),
        get: (...args) => api["adminCustomerAccountsGet"](...args),
        getById: (...args) => api["adminCustomerAccountsGetById"](...args),
        update: (...args) => api["adminCustomerAccountsUpdate"](...args)
    };
}
function createAdminIdentitiesClient(api) {
    return {
        update: (...args) => api["adminIdentitiesUpdate"](...args)
    };
}
function createAdminOrganizationsClient(api) {
    return {
        count: (...args) => api["adminOrganizationsCount"](...args),
        create: (...args) => api["adminOrganizationsCreate"](...args),
        get: (...args) => api["adminOrganizationsGet"](...args),
        update: (...args) => api["adminOrganizationsUpdate"](...args)
    };
}
function createAdminSAMLConfigClient(api) {
    return {
        delete: (...args) => api["adminSAMLConfigDelete"](...args),
        getById: (...args) => api["adminSAMLConfigGetById"](...args),
        update: (...args) => api["adminSAMLConfigUpdate"](...args)
    };
}
function createAdminSAMLConfigsClient(api) {
    return {
        get: (...args) => api["adminSAMLConfigsGet"](...args),
        samlConfigCreate: (...args) => api["samlConfigCreate"](...args)
    };
}
function createAssetsClient(api) {
    return {
        count: (...args) => api["assetsCount"](...args),
        create: (...args) => api["assetsCreate"](...args),
        getById: (...args) => api["assetsGetById"](...args),
        update: (...args) => api["assetsUpdate"](...args)
    };
}
function createAttachmentsClient(api) {
    return {
        count: (...args) => api["attachmentsCount"](...args),
        create: (...args) => api["attachmentsCreate"](...args),
        getByBuilding: (...args) => api["attachmentsGetByBuilding"](...args),
        getByOrganization: (...args) => api["attachmentsGetByOrganization"](...args),
        update: (...args) => api["attachmentsUpdate"](...args)
    };
}
function createAuthClient(api) {
    return {
        federate: (...args) => api["authFederate"](...args),
        forgotPassword: (...args) => api["authForgotPassword"](...args),
        passwordLogin: (...args) => api["authPasswordLogin"](...args),
        register: (...args) => api["authRegister"](...args),
        sendValidationEmail: (...args) => api["authSendValidationEmail"](...args)
    };
}
function createBuildingGroupsClient(api) {
    return {
        getByOrganization: (...args) => api["buildingGroupsGetByOrganization"](...args)
    };
}
function createBuildingLevelsClient(api) {
    return {
        getById: (...args) => api["buildingLevelsGetById"](...args)
    };
}
function createBuildingsClient(api) {
    return {
        count: (...args) => api["buildingsCount"](...args),
        getById: (...args) => api["buildingsGetById"](...args),
        getByOrganization: (...args) => api["buildingsGetByOrganization"](...args),
        update: (...args) => api["buildingsUpdate"](...args)
    };
}
function createImportsClient(api) {
    return {
        cancelImport: (...args) => api["cancelImport"](...args),
        getAssetImportFields: (...args) => api["getAssetImportFields"](...args),
        getBuildingImportFields: (...args) => api["getBuildingImportFields"](...args),
        getCSVResult: (...args) => api["getCSVResult"](...args),
        getRows: (...args) => api["getRows"](...args),
        importCSV: (...args) => api["importCSV"](...args),
        importRowActionsStats: (...args) => api["importRowActionsStats"](...args),
        importRowsStats: (...args) => api["importRowsStats"](...args)
    };
}
function createCatalogClient(api) {
    return {
        get: (...args) => api["catalogGet"](...args),
        update: (...args) => api["catalogUpdate"](...args)
    };
}
function createCatalogItemClient(api) {
    return {
        get: (...args) => api["catalogItemGet"](...args)
    };
}
function createCatalogItemsClient(api) {
    return {
        count: (...args) => api["catalogItemsCount"](...args),
        create: (...args) => api["catalogItemsCreate"](...args),
        delete: (...args) => api["catalogItemsDelete"](...args),
        get: (...args) => api["catalogItemsGet"](...args),
        update: (...args) => api["catalogItemsUpdate"](...args)
    };
}
function createCatalogsClient(api) {
    return {
        count: (...args) => api["catalogsCount"](...args),
        create: (...args) => api["catalogsCreate"](...args),
        get: (...args) => api["catalogsGet"](...args)
    };
}
function createChecklistTemplatesClient(api) {
    return {
        get: (...args) => api["checklistTemplatesGet"](...args),
        getById: (...args) => api["checklistTemplatesGetById"](...args)
    };
}
function createChecklistsClient(api) {
    return {
        count: (...args) => api["checklistsCount"](...args),
        get: (...args) => api["checklistsGet"](...args)
    };
}
function createChecklistsStatsClient(api) {
    return {
        group: (...args) => api["checklistsStatsGroup"](...args)
    };
}
function createCkeditorClient(api) {
    return {
        getToken: (...args) => api["ckeditorGetToken"](...args)
    };
}
function createConfirmationCodeClient(api) {
    return {
        create: (...args) => api["confirmationCodeCreate"](...args),
        createToken: (...args) => api["createToken"](...args),
        getCustomerAccounts: (...args) => api["getCustomerAccounts"](...args)
    };
}
function createCostDataClient(api) {
    return {
        getByBuilding: (...args) => api["costDataGetByBuilding"](...args)
    };
}
function createCostLinesClient(api) {
    return {
        getByBuilding: (...args) => api["costLinesGetByBuilding"](...args),
        getById: (...args) => api["costLinesGetById"](...args),
        getByOrganization: (...args) => api["costLinesGetByOrganization"](...args),
        update: (...args) => api["costLinesUpdate"](...args)
    };
}
function createCustomerAccountsClient(api) {
    return {
        countOrganizations: (...args) => api["countOrganizations"](...args),
        createOrganization: (...args) => api["createOrganization"](...args),
        defaultPermissionDelete: (...args) => api["customerAccountsDefaultPermissionDelete"](...args),
        defaultPermissionGet: (...args) => api["customerAccountsDefaultPermissionGet"](...args),
        defaultPermissionUpdate: (...args) => api["customerAccountsDefaultPermissionUpdate"](...args),
        defaultPermissionsCount: (...args) => api["customerAccountsDefaultPermissionsCount"](...args),
        defaultPermissionsCreate: (...args) => api["customerAccountsDefaultPermissionsCreate"](...args),
        defaultPermissionsGet: (...args) => api["customerAccountsDefaultPermissionsGet"](...args),
        getById: (...args) => api["customerAccountsGetById"](...args),
        update: (...args) => api["customerAccountsUpdate"](...args),
        deleteOrganization: (...args) => api["deleteOrganization"](...args),
        getAuthnMethods: (...args) => api["getAuthnMethods"](...args),
        getOrganizationGetById: (...args) => api["getOrganizationGetById"](...args),
        getOrganizations: (...args) => api["getOrganizations"](...args),
        updateOrganization: (...args) => api["updateOrganization"](...args)
    };
}
function createOrchestrationClient(api) {
    return {
        createCustomerAccountOrchestration: (...args) => api["createCustomerAccountOrchestration"](...args),
        createCustomerAccountOrchestrationSteps: (...args) => api["createCustomerAccountOrchestrationSteps"](...args),
        createSiteAdminOrchestration: (...args) => api["createSiteAdminOrchestration"](...args),
        createSiteAdminOrchestrationSteps: (...args) => api["createSiteAdminOrchestrationSteps"](...args),
        getCustomerAccountOrchestration: (...args) => api["getCustomerAccountOrchestration"](...args),
        getCustomerAccountOrchestrationSteps: (...args) => api["getCustomerAccountOrchestrationSteps"](...args),
        getCustomerAccountOrchestrationStepsCSV: (...args) => api["getCustomerAccountOrchestrationStepsCSV"](...args),
        getCustomerAccountOrchestrationStepsStats: (...args) => api["getCustomerAccountOrchestrationStepsStats"](...args),
        getCustomerAccountOrchestrations: (...args) => api["getCustomerAccountOrchestrations"](...args),
        getSiteAdminOrchestration: (...args) => api["getSiteAdminOrchestration"](...args),
        getSiteAdminOrchestrationSteps: (...args) => api["getSiteAdminOrchestrationSteps"](...args),
        getSiteAdminOrchestrationStepsCSV: (...args) => api["getSiteAdminOrchestrationStepsCSV"](...args),
        getSiteAdminOrchestrationStepsStats: (...args) => api["getSiteAdminOrchestrationStepsStats"](...args),
        getSiteAdminOrchestrations: (...args) => api["getSiteAdminOrchestrations"](...args),
        updateCustomerAccountOrchestration: (...args) => api["updateCustomerAccountOrchestration"](...args),
        updateSiteAdminOrchestration: (...args) => api["updateSiteAdminOrchestration"](...args)
    };
}
function createBrandingClient(api) {
    return {
        createTheme: (...args) => api["createTheme"](...args),
        deleteTheme: (...args) => api["deleteTheme"](...args),
        getActiveTheme: (...args) => api["getActiveTheme"](...args),
        getTheme: (...args) => api["getTheme"](...args),
        getThemes: (...args) => api["getThemes"](...args),
        siteAdminGetThemes: (...args) => api["siteAdminGetThemes"](...args),
        updateTheme: (...args) => api["updateTheme"](...args)
    };
}
function createCustomFieldAssociationClient(api) {
    return {
        delete: (...args) => api["customFieldAssociationDelete"](...args),
        update: (...args) => api["customFieldAssociationUpdate"](...args)
    };
}
function createCustomFieldAssociationsClient(api) {
    return {
        customFieldAssociationGet: (...args) => api["customFieldAssociationGet"](...args),
        create: (...args) => api["customFieldAssociationsCreate"](...args),
        get: (...args) => api["customFieldAssociationsGet"](...args)
    };
}
function createCustomFieldDefinitionClient(api) {
    return {
        delete: (...args) => api["customFieldDefinitionDelete"](...args),
        update: (...args) => api["customFieldDefinitionUpdate"](...args)
    };
}
function createCustomFieldDefinitionsClient(api) {
    return {
        customFieldDefinitionGet: (...args) => api["customFieldDefinitionGet"](...args),
        create: (...args) => api["customFieldDefinitionsCreate"](...args),
        get: (...args) => api["customFieldDefinitionsGet"](...args)
    };
}
function createCustomFieldEnumValueClient(api) {
    return {
        delete: (...args) => api["customFieldEnumValueDelete"](...args),
        update: (...args) => api["customFieldEnumValueUpdate"](...args)
    };
}
function createCustomFieldEnumValuesClient(api) {
    return {
        customFieldEnumValueGet: (...args) => api["customFieldEnumValueGet"](...args),
        count: (...args) => api["customFieldEnumValuesCount"](...args),
        create: (...args) => api["customFieldEnumValuesCreate"](...args),
        get: (...args) => api["customFieldEnumValuesGet"](...args)
    };
}
function createOrgCustomFieldValuesClient(api) {
    return {
        customFieldValuesGet: (...args) => api["customFieldValuesGet"](...args)
    };
}
function createCustomFieldValuesClient(api) {
    return {
        update: (...args) => api["customFieldValuesUpdate"](...args)
    };
}
function createDocumentsClient(api) {
    return {
        getByBuilding: (...args) => api["documentsGetByBuilding"](...args),
        upload: (...args) => api["documentsUpload"](...args)
    };
}
function createFieldGroupsClient(api) {
    return {
        getByOrganization: (...args) => api["fieldGroupsGetByOrganization"](...args)
    };
}
function createFilesClient(api) {
    return {
        fileCreate: (...args) => api["fileCreate"](...args),
        fileGet: (...args) => api["fileGet"](...args),
        completeUpload: (...args) => api["filesCompleteUpload"](...args),
        get: (...args) => api["filesGet"](...args)
    };
}
function createFlagsClient(api) {
    return {
        get: (...args) => api["flagsGet"](...args)
    };
}
function createIdentityClient(api) {
    return {
        countUsers: (...args) => api["identityCountUsers"](...args),
        createToken: (...args) => api["identityCreateToken"](...args),
        get: (...args) => api["identityGet"](...args),
        getUsers: (...args) => api["identityGetUsers"](...args)
    };
}
function createInspectionProgramsClient(api) {
    return {
        get: (...args) => api["inspectionProgramsGet"](...args),
        getCount: (...args) => api["inspectionProgramsGetCount"](...args)
    };
}
function createLevelsClient(api) {
    return {
        byOrganization: (...args) => api["levelsByOrganization"](...args),
        getById: (...args) => api["levelsGetById"](...args)
    };
}
function createMyExportsClient(api) {
    return {
        cancel: (...args) => api["myExportsCancel"](...args),
        create: (...args) => api["myExportsCreate"](...args),
        get: (...args) => api["myExportsGet"](...args),
        list: (...args) => api["myExportsList"](...args)
    };
}
function createMyImportsClient(api) {
    return {
        get: (...args) => api["myImportsGet"](...args),
        list: (...args) => api["myImportsList"](...args)
    };
}
function createOrganizationsClient(api) {
    return {
        count: (...args) => api["organizationsCount"](...args),
        delete: (...args) => api["organizationsDelete"](...args),
        get: (...args) => api["organizationsGet"](...args),
        getById: (...args) => api["organizationsGetById"](...args),
        update: (...args) => api["organizationsUpdate"](...args)
    };
}
function createPermissionGroupsClient(api) {
    return {
        get: (...args) => api["permissionGroupsGet"](...args)
    };
}
function createPinTypesClient(api) {
    return {
        count: (...args) => api["pinTypesCount"](...args),
        getById: (...args) => api["pinTypesGetById"](...args),
        getByOrganization: (...args) => api["pinTypesGetByOrganization"](...args)
    };
}
function createPortalClient(api) {
    return {
        assetsCreate: (...args) => api["portalAssetsCreate"](...args),
        attachmentsCreate: (...args) => api["portalAttachmentsCreate"](...args),
        documentsUpload: (...args) => api["portalDocumentsUpload"](...args),
        pinTypesGetById: (...args) => api["portalPinTypesGetById"](...args),
        pinTypesGetByOrganization: (...args) => api["portalPinTypesGetByOrganization"](...args)
    };
}
function createReportBlockContentClient(api) {
    return {
        previewReportBlockContent: (...args) => api["previewReportBlockContent"](...args),
        getById: (...args) => api["reportBlockContentGetById"](...args),
        update: (...args) => api["reportBlockContentUpdate"](...args)
    };
}
function createProcoreClient(api) {
    return {
        getMyCompanies: (...args) => api["procoreGetMyCompanies"](...args),
        getProjectsByCompany: (...args) => api["procoreGetProjectsByCompany"](...args),
        getProxy: (...args) => api["procoreGetProxy"](...args),
        isAppInstalled: (...args) => api["procoreIsAppInstalled"](...args),
        oauth: (...args) => api["procoreOauth"](...args),
        pullFiles: (...args) => api["procorePullFiles"](...args)
    };
}
function createReportBlocksClient(api) {
    return {
        delete: (...args) => api["reportBlocksDelete"](...args),
        getById: (...args) => api["reportBlocksGetById"](...args),
        getByOrganization: (...args) => api["reportBlocksGetByOrganization"](...args),
        update: (...args) => api["reportBlocksUpdate"](...args)
    };
}
function createReportContentClient(api) {
    return {
        getById: (...args) => api["reportContentGetById"](...args),
        update: (...args) => api["reportContentUpdate"](...args)
    };
}
function createReportHeadersAndFootersClient(api) {
    return {
        create: (...args) => api["reportHeadersAndFootersCreate"](...args),
        getById: (...args) => api["reportHeadersAndFootersGetById"](...args),
        getByOrganization: (...args) => api["reportHeadersAndFootersGetByOrganization"](...args),
        getContent: (...args) => api["reportHeadersAndFootersGetContent"](...args),
        update: (...args) => api["reportHeadersAndFootersUpdate"](...args),
        uploadContent: (...args) => api["reportHeadersAndFootersUploadContent"](...args)
    };
}
function createReportTemplateContentClient(api) {
    return {
        getById: (...args) => api["reportTemplateContentGetById"](...args),
        update: (...args) => api["reportTemplateContentUpdate"](...args)
    };
}
function createReportTemplatesClient(api) {
    return {
        count: (...args) => api["reportTemplatesCount"](...args),
        create: (...args) => api["reportTemplatesCreate"](...args),
        delete: (...args) => api["reportTemplatesDelete"](...args),
        getById: (...args) => api["reportTemplatesGetById"](...args),
        getByOrganization: (...args) => api["reportTemplatesGetByOrganization"](...args),
        updateById: (...args) => api["reportTemplatesUpdateById"](...args)
    };
}
function createReportsClient(api) {
    return {
        count: (...args) => api["reportsCount"](...args),
        create: (...args) => api["reportsCreate"](...args),
        delete: (...args) => api["reportsDelete"](...args),
        getById: (...args) => api["reportsGetById"](...args),
        getByOrganization: (...args) => api["reportsGetByOrganization"](...args),
        update: (...args) => api["reportsUpdate"](...args)
    };
}
function createRoomsClient(api) {
    return {
        getById: (...args) => api["roomsGetById"](...args)
    };
}
function createNotificationClient(api) {
    return {
        sendEmail: (...args) => api["sendEmail"](...args)
    };
}
function createTagsClient(api) {
    return {
        getByBuilding: (...args) => api["tagsGetByBuilding"](...args)
    };
}
function createUsersClient(api) {
    return {
        getById: (...args) => api["usersGetById"](...args),
        getByOrganization: (...args) => api["usersGetByOrganization"](...args),
        getMyUser: (...args) => api["usersGetMyUser"](...args)
    };
}
function createWebClient(api) {
    return {
        getAssets: (...args) => api["webGetAssets"](...args),
        getAssetsCount: (...args) => api["webGetAssetsCount"](...args),
        getBuildings: (...args) => api["webGetBuildings"](...args),
        getBuildingsCount: (...args) => api["webGetBuildingsCount"](...args),
        getChecklists: (...args) => api["webGetChecklists"](...args),
        getChecklistsCount: (...args) => api["webGetChecklistsCount"](...args),
        getCustomFieldAssociations: (...args) => api["webGetCustomFieldAssociations"](...args),
        getCustomFieldDefinitions: (...args) => api["webGetCustomFieldDefinitions"](...args),
        getFields: (...args) => api["webGetFields"](...args),
        getFieldsCount: (...args) => api["webGetFieldsCount"](...args),
        getPinTypeNames: (...args) => api["webGetPinTypeNames"](...args),
        getReportBlockAssetCount: (...args) => api["webGetReportBlockAssetCount"](...args),
        getReportBlockAssets: (...args) => api["webGetReportBlockAssets"](...args),
        getReportBlockBuildingCount: (...args) => api["webGetReportBlockBuildingCount"](...args),
        getReportBlockBuildings: (...args) => api["webGetReportBlockBuildings"](...args),
        getWorkOrders: (...args) => api["webGetWorkOrders"](...args)
    };
}
function createWorkOrdersClient(api) {
    return {
        get: (...args) => api["workOrdersGet"](...args),
        getById: (...args) => api["workOrdersGetById"](...args),
        getCount: (...args) => api["workOrdersGetCount"](...args)
    };
}
function createAkitaBoxClient(api) {
    return {
        adminCustomerAccounts: createAdminCustomerAccountsClient(api),
        adminIdentities: createAdminIdentitiesClient(api),
        adminOrganizations: createAdminOrganizationsClient(api),
        adminSAMLConfig: createAdminSAMLConfigClient(api),
        adminSAMLConfigs: createAdminSAMLConfigsClient(api),
        assets: createAssetsClient(api),
        attachments: createAttachmentsClient(api),
        auth: createAuthClient(api),
        buildingGroups: createBuildingGroupsClient(api),
        buildingLevels: createBuildingLevelsClient(api),
        buildings: createBuildingsClient(api),
        imports: createImportsClient(api),
        catalog: createCatalogClient(api),
        catalogItem: createCatalogItemClient(api),
        catalogItems: createCatalogItemsClient(api),
        catalogs: createCatalogsClient(api),
        checklistTemplates: createChecklistTemplatesClient(api),
        checklists: createChecklistsClient(api),
        checklistsStats: createChecklistsStatsClient(api),
        ckeditor: createCkeditorClient(api),
        confirmationCode: createConfirmationCodeClient(api),
        costData: createCostDataClient(api),
        costLines: createCostLinesClient(api),
        customerAccounts: createCustomerAccountsClient(api),
        orchestration: createOrchestrationClient(api),
        branding: createBrandingClient(api),
        customFieldAssociation: createCustomFieldAssociationClient(api),
        customFieldAssociations: createCustomFieldAssociationsClient(api),
        customFieldDefinition: createCustomFieldDefinitionClient(api),
        customFieldDefinitions: createCustomFieldDefinitionsClient(api),
        customFieldEnumValue: createCustomFieldEnumValueClient(api),
        customFieldEnumValues: createCustomFieldEnumValuesClient(api),
        orgCustomFieldValues: createOrgCustomFieldValuesClient(api),
        customFieldValues: createCustomFieldValuesClient(api),
        documents: createDocumentsClient(api),
        fieldGroups: createFieldGroupsClient(api),
        files: createFilesClient(api),
        flags: createFlagsClient(api),
        identity: createIdentityClient(api),
        inspectionPrograms: createInspectionProgramsClient(api),
        levels: createLevelsClient(api),
        myExports: createMyExportsClient(api),
        myImports: createMyImportsClient(api),
        organizations: createOrganizationsClient(api),
        permissionGroups: createPermissionGroupsClient(api),
        pinTypes: createPinTypesClient(api),
        portal: createPortalClient(api),
        reportBlockContent: createReportBlockContentClient(api),
        procore: createProcoreClient(api),
        reportBlocks: createReportBlocksClient(api),
        reportContent: createReportContentClient(api),
        reportHeadersAndFooters: createReportHeadersAndFootersClient(api),
        reportTemplateContent: createReportTemplateContentClient(api),
        reportTemplates: createReportTemplatesClient(api),
        reports: createReportsClient(api),
        rooms: createRoomsClient(api),
        notification: createNotificationClient(api),
        tags: createTagsClient(api),
        users: createUsersClient(api),
        web: createWebClient(api),
        workOrders: createWorkOrdersClient(api)
    };
}
exports.createAkitaBoxClient = createAkitaBoxClient;
//# sourceMappingURL=akitaBoxClient.js.map